import { read } from 'xlsx'

import { createNewBudget } from './data'

import utils from './utils'

const numToDate = function (val) {
  return val ? moment((val - 25569) * 24 * 60 * 60 * 1000).format('YYYY-MM-DD') : undefined
}

const strToDate = function (val) {
  return val ? moment(val).format('YYYY-MM-DD') : undefined
}

const getCellValue = (data, cell, defaultValue) => (data[cell] && data[cell].v ? `${data[cell].v}`.trim() : defaultValue)
// const getCellNumberValue = (data, cell, defaultValue = 0) => (data[cell] && data[cell].v ? parseFloat(data[cell].v) : defaultValue)

const getCellNumberValue = (data, cell, defaultValue = 0) => {
  if (data[cell] && data[cell].v) {
    return parseFloat(data[cell].v)
  }
  return defaultValue
  // (data[cell] && data[cell].v ? parseFloat(data[cell].v) : defaultValue)
}
const getCellDateValue = (data, cell, defaultValue) => (data[cell] ? (data[cell].t === 'n' ? numToDate(data[cell].v) : strToDate(data[cell].v)) : defaultValue)

export function readExcel(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = e => {
      try {
        const data = read(e.target.result, {
          type: 'binary',
          sheets: 0,
        })
        let { SheetNames, Sheets } = data
        resolve(Sheets[SheetNames[0]])
      } catch (e) {
        reject('文件读取失败')
      }
    }
    reader.onerror = () => {
      reject('文件读取失败')
    }
    reader.readAsBinaryString(file)
  })
}

export function readBudgetData(file) {
  return new Promise((resolve, reject) => {
    readExcel(file)
      .then(data => {
        console.log('readExcel', data)
        let maxRow = 0
        try {
          maxRow = +data['!ref'].split(':')[1].replace(/[^\d]/, '')
        } catch {
          reject('导入文件内容不符合要求')
          return
        }
        let taskHeaderCol = Object.keys(data).find(col => data[col].v === '项目内容')
        if (!taskHeaderCol) {
          reject('导入文件内容不符合要求')
          return
        }
        let records = []
        let startRow = +taskHeaderCol.substr(1)
        for (let row = startRow + 2; row <= maxRow; row++) {
          let name = getCellValue(data, `B${row}`, '')
          if (name == '小结') {
            continue
          }
          if (name == '合计' || name == '') {
            break
          }
          let record = createNewBudget()
          record.name = name.endsWith('：') ? name.slice(0, -1) : name
          record.isRoot = 1
          record.uid = utils.uuid()
          let children = []
          let childRow = row
          for (; childRow < maxRow ; childRow++) {
            let parentName = getCellValue(data, `B${childRow}`, '')
            if (parentName == '小结' || parentName == '合计') {
              break
            }
            let childName = getCellValue(data, `C${childRow}`, '')
            if (childName == '') {
              break
            }
            let child = createNewBudget()
            child.uid = utils.uuid()
            child.name = childName
            child.puid = record.uid
            child.price = getCellNumberValue(data, `D${childRow}`, undefined)
            child.quantity = getCellNumberValue(data, `E${childRow}`, undefined)
            child.amount = getCellNumberValue(data, `F${childRow}`, undefined)
            child.year = getCellValue(data, `O${childRow}`, undefined)
            children.push(child)
          }
          if (children.length) {
            record.children = children
          }
          records.push(record)
          row = childRow
        }
        // result.records = records
        resolve(records)
      })
      .catch(error => {
        reject(error)
      })
  })
}
